import Counter from './Counter';

export default class CounterController {
  constructor() {
    this.allCounters = document.querySelectorAll('.wp-counter');
    this.allCounters.forEach((counter) => {
      new Counter(counter, 20);
    });
  }
}